import { createContext, RefObject} from "react";
import { CommerceFirmData, FirmAddress, Individual, UserConfiguration } from "../models";

export const UserContext = createContext<UserPermission | undefined>(undefined);

export const PageContainerContext = createContext<RefObject<HTMLDivElement> | undefined>(undefined);

export type UserRole = "Admin" | "ManagingPartner" | "FirmCommerceManagement" | "ServiceContact" | "VendorUser"
export type VendorRole = 4 | 5


export interface UserPermission {
	firmAddress: FirmAddress;
	roles: (UserRole)[];
	individual: Individual;
	userConfiguration: UserConfiguration;
	highlyAuthoritativeUsers: boolean;
	myServices: CommerceFirmData[];
	avatar: string;
	orgType: number;
	fileNamePrintPdf: string;
}
